import * as yup from 'yup';

function email(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'EMAIL_MUST_BE_A_VALID_EMAIL_ADDRESS',
        defaultMessage: 'Email must be a valid email address',
      }),
    )
    .test(
      'has-tld',
      formatMessage({
        id: 'EMAIL_MUST_HAVE_A_VALID_TOP_LEVEL_DOMAIN',
        defaultMessage: 'Email must have a valid top-level domain',
      }),
      value => {
        return value
          ? /\.[a-zA-Z]{2,}$/.test(value.split('@')[1] || '')
          : false;
      },
    )
    .required(
      formatMessage({
        id: 'EMAIL_IS_REQUIRED',
        defaultMessage: 'Email is required',
      }),
    );
}

function firstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'FIRST_NAME_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function lastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'LAST_NAME_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function enabled(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function role(formatMessage) {
  return yup.object().required(
    formatMessage({
      id: 'ROLE_IS_REQUIRED',
      defaultMessage: 'Role is required',
    }),
  );
}

function customerNewPassword(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'PASSWORD_IS_REQUIRED',
      defaultMessage: 'Password is required',
    }),
  );
}

function customerRetypePassword(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'PLEASE_CONFIRM_YOUR_PASSWORD',
        defaultMessage: 'Please confirm your password',
      }),
    )
    .oneOf(
      [yup.ref('customerNewPassword'), null],
      formatMessage({
        id: 'PASSWORDS_MUST_MATCH',
        defaultMessage: 'Passwords must match',
      }),
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      email: email(formatMessage),
      firstName: firstName(formatMessage),
      lastName: lastName(formatMessage),
      enabled: enabled(formatMessage),
      role: role(formatMessage),
      customerNewPassword: customerNewPassword(formatMessage),
      customerRetypePassword: customerRetypePassword(formatMessage),
    })
    .required();

export default validationSchema;
